import React, { Component } from 'react';
import PropTypes from 'prop-types';

class Alert extends Component {
  static defaultProps = {
    type: 'error',
  };

  constructor(props) {
    super(props);

    this.state = {
      active: true,
      closing: false,
    };
  }

  componentDidMount() {
    this.timeoutAlert();
  }

  componentDidUpdate(prevProps, prevState) {
    if (!prevState.active) {
      this.setState({
        active: true,
        closing: false,
      });

      this.timeoutAlertClear();
      this.timeoutAlert();
    }
  }

  componentWillUnmount() {
    this.timeoutAlertClear();
  }

  closeAlert = () => {
    this.setState({
      closing: true,
    });
  };

  hideAlert = () => {
    this.setState({
      closing: false,
      active: false,
    });
  };

  timeoutAlert = () => {
    this.alerTimer = setTimeout(this.closeAlert, 5000);
  };

  timeoutAlertClear = () => {
    clearTimeout(this.alerTimer);
  };

  render() {
    const { children, type } = this.props;
    const { active, closing } = this.state;

    return (
      active && (
        <div
          role="alertdialog"
          aria-live="assertive"
          className={'alert alert--' + type + (closing ? ' closing' : '')}
          onAnimationEnd={() => (closing ? this.hideAlert() : null)}
        >
          {children}
        </div>
      )
    );
  }
}

Alert.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  type: PropTypes.string.isRequired,
};

export default Alert;
